export const IMAGES = [
  '/images/portfolio/magimira 2026.jpeg',
  '/images/portfolio/pinky.jpeg',
  '/images/portfolio/tonedeaf.jpeg',
  '/images/portfolio/Kay-kaypxz-PIP.jpg',
  '/images/portfolio/galasynth.jpeg',
  '/images/portfolio/space miku.jpeg',
  '/images/portfolio/miku birthday 2.jpeg',
  '/images/portfolio/magical mirai.jpeg',
  '/images/portfolio/second_sound_v3.jpg',
  '/images/portfolio/miku birday.jpeg',
  '/images/portfolio/ouas.jpeg',
  '/images/portfolio/fortnite.jpeg',
  '/images/portfolio/miku_day_2025_v2.jpg',
  '/images/portfolio/promise.jpeg',
  '/images/portfolio/idolRin.jpeg',
  '/images/portfolio/40.jpg',
  '/images/portfolio/siblings.jpeg',
  '/images/portfolio/milkshake.jpeg',
  '/images/portfolio/processing.jpeg',
  '/images/portfolio/star rin.jpeg',
  '/images/portfolio/twisted.jpeg',
  '/images/portfolio/14.jpg',
  '/images/portfolio/30.jpg',
  '/images/portfolio/28.jpg',
  '/images/portfolio/11.jpg',
  '/images/portfolio/32.jpg',
];
